export const GET_CURRENT_SOLUTION = 'GET_CURRENT_SOLUTION';


